import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@shared/api/base/base';
import { API_CACHE_TIME } from '@shared/config/api/api-base';

export const inputFileSearchBaseApi = createApi({
    reducerPath: 'inputFileSearchApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: [],
    endpoints: () => ({}),
    keepUnusedDataFor: API_CACHE_TIME,
});
